/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import * as CryptoJS from 'crypto-js';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { EnvVariables } from '../../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../../../providers/session';
import { InstrumentHubProvider } from '../../../providers/serverHubs/instrument';
import { ReturnStatement } from '@angular/compiler';


@Injectable()
export class Market_SessionInstrumentStore {
  public params: any;
  private paramsKey: string;
  private defaultParams: any;
  private isPersistParams: boolean;
  public isServerPush = false;
  /// *** Data
  private sessionInstrumentStore: any;
  public activeSessionInstrument: any = {};
  constructor(
    // *** System
    private events: Events,
    private storage: Storage,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider,
    private instrumentHubProvider: InstrumentHubProvider) {
  }

  /// *** Configurer les paramètres
  public configParams(defaultParams: any, isPersistParams: boolean) {
    this.paramsKey = '_Market_SessionInstrumentPage.local';
    this.params = defaultParams;
    this.defaultParams = defaultParams;
    this.isPersistParams = isPersistParams;
  }

  /// *** Récupérer les paramètres de la page
  public loadParams() {
    if (this.isPersistParams) {
      return this.storage.get(this.paramsKey).then(
        (data) => {
          if (data) {
            var paramsStr: string = CryptoJS.AES.decrypt(data.toString(), this.globals.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
            this.params = JSON.parse(paramsStr);
          }
          else {
            this.params = deepCopy(this.defaultParams);
            this.persistParams();
          }
        },
        (error) => {
          this.params = deepCopy(this.defaultParams);
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
    else {
      return new Promise<any>((resolve, reject) => { resolve() });
    }
  }

  /// *** Persister les paramètres de la page
  public persistParams() {
    if (this.isPersistParams) {
      var dataCrypt: string = CryptoJS.AES.encrypt(JSON.stringify(this.params), this.globals.CRYPTO_KEY).toString();
      return this.storage.set(this.paramsKey, dataCrypt).then(
        (succeed) => { },
        (error) => {
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
  }

  /// *** Charger le portfeuille du compte
  public load(isRefresh: boolean = false) {
    return new Promise((resolve, reject) => {
      if (isRefresh)
        this.reset();
      let sessionInstrument = null;
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let requestParams = new URLSearchParams();
      requestParams.append('UserID', this.session.data.userID);
      requestParams.append('ISINCode', this.params.iSINCode);
      let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
      this.http.get(this.envVariables.marketInstrumentInfosApiEndpoint, options).map(res => res.json()).subscribe(
        (data) => {
          sessionInstrument = data;
          // Intraday
          requestParams = new URLSearchParams();
          requestParams.append('ISINCode', this.params.iSINCode);
          let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
          this.http.get(this.envVariables.marketInstrumentIntraDayApiEndpoint, options).map(res => res.json()).subscribe(
            (data) => {
              sessionInstrument.intraday = data;
              // Depth
              this.http.get(this.envVariables.marketInstrumentDepthApiEndpoint, options).map(res => res.json()).subscribe(
                (data) => {
                  sessionInstrument.depth = data;
                  // Trades
                  this.http.get(this.envVariables.marketInstrumentTransactionsApiEndpoint, options).map(res => res.json()).subscribe(
                    (data) => {
                      sessionInstrument.trades = data;
                      // History
                      this.http.get(this.envVariables.marketInstrumentHistoryApiEndpoint, options).map(res => res.json()).subscribe(
                        (data) => {
                          sessionInstrument.history = data;
                          // Finalize
                          this.sessionInstrumentStore = deepCopy(sessionInstrument);
                          this.activeSessionInstrument = deepCopy(sessionInstrument);
                          this.sort();
                          this.events.publish('Market_SessionInstrumentStore.load');
                          this._eventsSub();
                          resolve();
                        },
                        (error) => {
                          this.globals.showCommunicationError(this.toastCtrl, error);
                          reject();
                        });
                    },
                    (error) => {
                      this.globals.showCommunicationError(this.toastCtrl, error);
                      reject();
                    });
                },
                (error) => {
                  this.globals.showCommunicationError(this.toastCtrl, error);
                  reject();
                });
            },
            (error) => {
              this.globals.showCommunicationError(this.toastCtrl, error);
              reject();
            });
        },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject();
        });
    });
  }

  // *** Recherche dans la liste des instruments
  public search(ev) {
  }

  // *** Trier les instruments
  public sort() {
  }

  // *** Remise à zéro des informations du portefeuille
  public reset() {
    this.activeSessionInstrument = {};
    this.events.publish('Market_SessionInstrumentStore.reset');
    this._eventsUnsub();
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsSub() {
    try {
      this.instrumentHubProvider.subscribe(this.params.iSINCode);
      // On 'updateTheoreticalOpeningPrice'
      this.events.subscribe('InstrumentHubProvider.updateTheoreticalOpeningPrice', (instrumentData: any) => {
        try {
          // Active
          this.isServerPush = true;
          this.activeSessionInstrument.TheoreticalOpeningPrice = instrumentData.TheoreticalOpeningPrice;
          this.activeSessionInstrument.TheoreticalPriceVariation = instrumentData.TheoreticalPriceVariation;
          this.activeSessionInstrument.TheoreticalPriceVariationSide = instrumentData.TheoreticalPriceVariationSide;
          this.activeSessionInstrument.TheoreticalOpeningQuantity = instrumentData.TheoreticalOpeningQuantity;
          this.activeSessionInstrument.TheoreticalOpeningVolume = instrumentData.TheoreticalOpeningVolume;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionInstrumentStore.TheoreticalOpeningPrice = instrumentData.TheoreticalOpeningPrice;
          this.sessionInstrumentStore.TheoreticalPriceVariation = instrumentData.TheoreticalPriceVariation;
          this.sessionInstrumentStore.TheoreticalPriceVariationSide = instrumentData.TheoreticalPriceVariationSide;
          this.sessionInstrumentStore.TheoreticalOpeningQuantity = instrumentData.TheoreticalOpeningQuantity;
          this.sessionInstrumentStore.TheoreticalOpeningVolume = instrumentData.TheoreticalOpeningVolume;
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateStaticThresholds'
      this.events.subscribe('InstrumentHubProvider.updateStaticThresholds', (instrumentData: any) => {
        try {
          // Active
          this.isServerPush = true;
          this.activeSessionInstrument.UpperThreshold = instrumentData.UpperThreshold;
          this.activeSessionInstrument.LowerThreshold = instrumentData.LowerThreshold;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionInstrumentStore.UpperThreshold = instrumentData.UpperThreshold;
          this.sessionInstrumentStore.LowerThreshold = instrumentData.LowerThreshold;
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateOpeningSummary'
      this.events.subscribe('InstrumentHubProvider.updateOpeningSummary', (instrumentData: any) => {
        try {
          // Active
          this.isServerPush = true;
          this.activeSessionInstrument.OpeningPrice = instrumentData.OpeningPrice;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionInstrumentStore.OpeningPrice = instrumentData.OpeningPrice;
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updatePrice'
      this.events.subscribe('InstrumentHubProvider.updatePrice', (instrumentData: any) => {
        try {
          // Active
          this.isServerPush = true;
          this.activeSessionInstrument.ClosingPrice = instrumentData.ClosingPrice;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionInstrumentStore.ClosingPrice = instrumentData.ClosingPrice;
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateInstrumentTrade'
      this.events.subscribe('InstrumentHubProvider.updateInstrumentTrade', (instrumentData: any, tradeData: any, valuationData: any) => {
        try {
          // Active
          this.isServerPush = true;
          this.activeSessionInstrument.LastPrice = instrumentData.LastPrice;
          this.activeSessionInstrument.LastPriceVariation = instrumentData.LastPriceVariation;
          this.activeSessionInstrument.LastPriceVariationSide = instrumentData.LastPriceVariationSide;
          this.activeSessionInstrument.LowestPrice = instrumentData.LowestPrice;
          this.activeSessionInstrument.HighestPrice = instrumentData.HighestPrice;
          this.activeSessionInstrument.Volume = instrumentData.Volume;
          this.activeSessionInstrument.TotalQuantity = instrumentData.TotalQuantity;
          this.activeSessionInstrument.intraday.push([tradeData.TradeTime, tradeData.Price]);
          this.activeSessionInstrument.trades.splice(0, 0, tradeData);
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionInstrumentStore.LastPrice = instrumentData.LastPrice;
          this.sessionInstrumentStore.LastPriceVariation = instrumentData.LastPriceVariation;
          this.sessionInstrumentStore.LastPriceVariationSide = instrumentData.LastPriceVariationSide;
          this.sessionInstrumentStore.LowestPrice = instrumentData.LowestPrice;
          this.sessionInstrumentStore.HighestPrice = instrumentData.HighestPrice;
          this.sessionInstrumentStore.Volume = instrumentData.Volume;
          this.sessionInstrumentStore.TotalQuantity = instrumentData.TotalQuantity;
          this.sessionInstrumentStore.intraday.push([tradeData.TradeTime, tradeData.Price]);
          this.sessionInstrumentStore.trades.splice(0, 0, tradeData);
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateInstrumentState'
      this.events.subscribe('InstrumentHubProvider.updateInstrumentState', (instrumentData: any) => {
        try {
          // Active
          this.isServerPush = true;
          this.activeSessionInstrument.State = instrumentData.State;
          this.activeSessionInstrument.StateTime = instrumentData.StateTime;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionInstrumentStore.State = instrumentData.State;
          this.sessionInstrumentStore.StateTime = instrumentData.StateTime;
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateMarketDepth'
      this.events.subscribe('InstrumentHubProvider.updateMarketDepth', (marketDepthData: any) => {
        try {
          this.isServerPush = true;
          this.activeSessionInstrument.depth = deepCopy(marketDepthData);
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          this.sessionInstrumentStore.depth = deepCopy(marketDepthData);
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsUnsub() {
    try {
      this.events.unsubscribe('InstrumentHubProvider.updateTheoreticalOpeningPrice');
      this.events.unsubscribe('InstrumentHubProvider.updateStaticThresholds');
      this.events.unsubscribe('InstrumentHubProvider.updateOpeningSummary');
      this.events.unsubscribe('InstrumentHubProvider.updatePrice');
      this.events.unsubscribe('InstrumentHubProvider.updateInstrumentTrade');
      this.events.unsubscribe('InstrumentHubProvider.updateInstrumentState');
      this.events.unsubscribe('InstrumentHubProvider.updateMarketDepth');
      this.events.publish('InstrumentHubProvider.abord');
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/sessionInstrument/sessionInstrument.store.ts